export type FeedSort = "hottest" | "latest";
/** Top-level feed view: the two sorts of the main feed, or the Following feed. */
export type FeedMode = FeedSort | "following";

export const FEED_SORT_ORDER: Record<FeedSort, { field: string; direction: string }[]> = {
  hottest: [{ field: "score", direction: "DESC" }],
  latest: [{ field: "CreatedDate", direction: "DESC" }],
};
